import WheelPlayer from '@/store/models/games/wheel/WheelPlayer'
import {
  GAME_WHEEL_HISTORY,
  GAME_WHEEL_ROLL,
  GAME_WHEEL_ROUND,
  GAME_WHEEL_BET,
  GAME_WHEEL_DELETE_BET,
  GAME_WHEEL_LOCKED,
} from '@/utils/constants/socket-events'
import { INTERLUDE_DURATION, WHEEL_FIELDS } from '@/views/games/Wheel/utils'

const INITIAL_BETS = () => ({
  1: 0, 3: 0, 5: 0, 10: 0, 20: 0,
})

export default {
  [`SOCKET_${GAME_WHEEL_ROUND}`]({ commit, rootGetters }, round) {
    commit('setOpen', round.open)
    commit('setShowWinnings', false)
    commit('setRoundId', round.id)
    commit('setLockTs', Date.now() + round.lockingAtDifferenceMs)

    if (round.rolledAt) {
      commit('setRollTs', Date.now() + round.rolledAtDifferenceMs)
    } else {
      commit('setRollTs', null)
    }

    commit('setOutcome', round.outcome ?? null)
    commit('setFairness', round.fairness)

    const players = round.bets || {}
    WheelPlayer.create({
      data: Object.values(players).map(i => ({
        id: i.user.steamid,
        user: i.user,
        bets: i.bets,
      })),
    })

    const user = rootGetters['user/session']
    const userBets = players?.[user?.steamid]?.bets

    commit('setBets', userBets ?? INITIAL_BETS())
  },
  [`SOCKET_${GAME_WHEEL_LOCKED}`]({ commit }) {
    commit('setOpen', false)
  },
  [`SOCKET_${GAME_WHEEL_BET}`]({ commit }, bet) {
    // TODO batch updates to 500ms
    WheelPlayer.insertOrUpdate({
      data: {
        id: bet.user.steamid,
        ...bet,
      },
    })
  },
  [`SOCKET_${GAME_WHEEL_DELETE_BET}`]({ commit }, steamid) {
    WheelPlayer.delete(steamid)
  },
  [`SOCKET_${GAME_WHEEL_ROLL}`]({ commit, getters, rootGetters }, round) {
    commit('setOpen', false)
    commit('setFairness', round.fairness)
    commit('setRollTs', Date.now())
    commit('setOutcome', round.outcome)

    // save user's last bet
    const { betsTotal, bets } = getters
    if (betsTotal > 0) {
      if (bets[20] >= 1e2) {
        // NOTE gleam
        const Gleam = window.Gleam || []
        Gleam.push(['wheel-20x-bet-hiyQLkXbH3UJk', ''])
      }

      commit('setLastBets', { ...bets })
    }

    // add round to history
    const { roundId, rollTs, lockTs } = getters
    const conga = rootGetters['conga/conga']
    const duration = conga.games.wheel.time.newRound - INTERLUDE_DURATION + 500

    setTimeout(() => {
      commit('addHistoryRound', {
        id: roundId,
        fairness: round.fairness,
        outcome: round.outcome,
        data: {
          field: WHEEL_FIELDS[round.outcome],
        },
        lockingAt: lockTs,
        rolledAt: rollTs,
      })

      commit('setShowWinnings', true)
    }, duration)
  },
  [`SOCKET_${GAME_WHEEL_HISTORY}`]({ commit, state, rootGetters }, data) {
    const history = data

    // dont spoil current round
    if (state.roundId && state.roundId === history[0]?.id && history[0].rolledAt) {
      const round = history.shift()

      // add it back in when roll is done
      const conga = rootGetters['conga/conga']
      const rollTs = new Date(round.rolledAt).getTime()
      const rollAnimStopsAt = rollTs + conga.games.wheel.time.newRound - INTERLUDE_DURATION
      const duration = rollAnimStopsAt - Date.now()

      // this doesnt get cancelled when a new one is called but honestly who cares bro
      setTimeout(() => {
        commit('addHistoryRound', round)
      }, Math.max(duration, 1))
    }

    commit('setHistory', history)
  },
}
